import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientHydration, withNoIncrementalHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';

// Firebase imports
import { provideFirebase } from './_firebase/firebase.service';

// Other imports
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { IMAGE_CONFIG } from '@angular/common';
import { provideQuillConfig } from 'ngx-quill';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(withNoIncrementalHydration()),
    provideAnimations(), // Animations must be provided before other UI-related providers
    provideQuillConfig({}),
    provideFirebase(environment.firebase),
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true, 
        disableImageLazyLoadWarning: true
      }
    }
  ]
};
